import { Card, CardContent, CardHeader, CardTitle } from '@repo/shadcn';
import { useEffect, useState } from 'react';
import {
    Bar,
    BarChart,
    CartesianGrid,
    Legend,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts';

import { useDashboard } from '../../dashboard.provider';

export const SalesReport = () => {
    return (
        <Card className="mx-auto w-full  max-w-full ">
            <CardHeader>
                <CardTitle>Sales Report</CardTitle>
            </CardHeader>
            <CardContent>
                <SalesChart />
            </CardContent>
        </Card>
    );
};

const SalesChart = () => {
    const { salesData } = useDashboard();
    const [data, setData] = useState<
        {
            name: string;
            Total: number;
            Paid: number;
            Due: number;
        }[]
    >([]);
    useEffect(() => {
        const sale = salesData?.map((item) => ({
            name: item.month_name.slice(0, 3),
            Total: item.total_orders,
            Paid: item.complete_orders,
            Due: item.due_orders,
        }));
        if (sale) {
            setData(sale);
        }
    }, [salesData]);
    return (
        <div className="h-[440px] w-full">
            <ResponsiveContainer>
                <BarChart
                    data={data}
                    margin={{
                        top: 5,
                        right: 0,
                        left: 0,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="Total" fill="#155E95" />
                    <Bar dataKey="Paid" fill="#77B254" />
                    <Bar dataKey="Due" fill="#EB5A3C" />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};
